import { OnAnimationFrame } from "../../../../library-js/animation/OnAnimationFrame";
import { DateMath } from "../../../../library-js/date/DateMath";
import { AttributeValue } from "../../../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType"
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { DateFormater } from "../../../../library-js/text/DateFormater";

export class TimeZones
{
  static readonly type = new ElementType( "time-zones" );
  static readonly zone = new ElementType( "time-zone" );
  static readonly offset = new ElementAttribute( "offset" );
  
  static onAnimationFrame:OnAnimationFrame;
  static zones:Element[] = [];
  static dateElement:Element = null;

  static applyOnDocument( onAnimationFrame:OnAnimationFrame )
  {
    if ( ! TimeZones.onAnimationFrame )
    {
      TimeZones.onAnimationFrame = onAnimationFrame;
      onAnimationFrame.addListener( ()=>{ TimeZones.update(); })
    }

    TimeZones.type.forAllInDoc( d => this.applyOnElement( d ) );
  }

  static update()
  {
    this.applyZones( this.zones );
  }

  static applyOnElement( e:Element )
  {
    TimeZones.dateElement = e;

    let zones = TimeZones.zone.queryAll( e );
    this.zones = zones;


    TimeZones.applyZones( zones );
  }

  static applyZones( zones:Element[] )
  {
    if ( ! this.zones || this.zones.length === 0 || this.dateElement == null )
    {
      return;
    }


    let inputDate = AttributeValue.type_date.query( this.dateElement ) as HTMLInputElement;
    let inputTime = AttributeValue.type_time.query( this.dateElement ) as HTMLInputElement;

    let dateValue = inputDate.value;
    let timeValue = inputTime.value;

    let date = new Date( dateValue );
    date.setHours( 0, 0, 0, 0 );

    let time = new Date('1970-01-01' + ' ' + timeValue + 'Z').getTime();

    let combinedDate = new Date( date.getTime() + time );

    zones.forEach( z => TimeZones.applyZone( combinedDate, z ) );
  }

  static applyZone( utcDate:Date, zone:Element )
  { 
    let offset = TimeZones.offset.asNumberFrom( zone, 0 );

    let copiedDate = new Date( utcDate.getTime() + offset * 60 * 60 * 1000 );
    let dateString = DateFormater.format( copiedDate, DateFormater.DEFAULT_FORMAT_REVERSE );

    HTMLEditor.setText( zone, dateString );
  }
}